import styled from 'styled-components';

const variantColors = {
  info: {
    bg: '#eff6ff',
    border: '#dbeafe',
    icon: '#3b82f6',
    darkBg: 'rgba(59, 130, 246, 0.1)',
    darkBorder: 'rgba(59, 130, 246, 0.2)',
  },
  success: {
    bg: '#f0fdf4',
    border: '#dcfce7',
    icon: '#22c55e',
    darkBg: 'rgba(34, 197, 94, 0.1)',
    darkBorder: 'rgba(34, 197, 94, 0.2)',
  },
  warning: {
    bg: '#fffbeb',
    border: '#fef3c7',
    icon: '#f59e0b',
    darkBg: 'rgba(245, 158, 11, 0.1)',
    darkBorder: 'rgba(245, 158, 11, 0.2)',
  },
  tip: {
    bg: '#faf5ff',
    border: '#f3e8ff',
    icon: '#a855f7',
    darkBg: 'rgba(168, 85, 247, 0.1)',
    darkBorder: 'rgba(168, 85, 247, 0.2)',
  },
};

export const CalloutContainer = styled.div<{ $variant: 'info' | 'success' | 'warning' | 'tip' }>`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 6px;
  background: ${({ theme, $variant }) => (theme.mode === 'dark' ? variantColors[$variant].darkBg : variantColors[$variant].bg)};
  border: 1px solid ${({ theme, $variant }) => (theme.mode === 'dark' ? variantColors[$variant].darkBorder : variantColors[$variant].border)};
`;

export const CalloutIcon = styled.div<{ $variant?: 'info' | 'success' | 'warning' | 'tip' }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 40px;
  height: 40px;

  svg {
    width: 24px;
    height: 24px;
    color: ${({ theme, $variant = 'info' }) => (theme.mode === 'dark' ? variantColors[$variant].icon : variantColors[$variant].icon)};
  }

  img {
    width: 40px;
    height: 40px;
    object-fit: contain;
  }
`;

export const CalloutContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const CalloutTitle = styled.h4`
  margin: 0;
  font-size: 14px;
  font-weight: 300;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#f3f4f6' : '#1e293b')};
  line-height: 1.4;
`;

export const CalloutText = styled.p`
  margin: 0;
  font-size: 13px;
  font-weight: 400;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#d1d5db' : '#64748b')};
  line-height: 1.5;
`;
